import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  copyDirectLinkLabel: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel',
    defaultMessage: 'Copy direct link',
    description: 'Label for a menu item that copies a link to issue forms direct for the selected form to the clipboard.'
  },
  requestTypesHeader: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader',
    defaultMessage: 'Request type',
    description: 'Header for the submenu containing a list of request types to select, in JSM projects.'
  },
  issueTypesHeader: {
    id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader',
    defaultMessage: 'Issue type',
    description: 'Header for the submenu containing a list of request types to select, in non-JSM projects.'
  }
});